"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const calculation_1 = require("@wurzel/uzb-calculation/dist/calculation");
const util_1 = require("./util");
function getVariablesWorkInstructions(move, configuration) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    const calculation = calculation_1.calculate(move, configuration);
    const packingMaterials = configuration.packingMaterials;
    const packmaterialVorab = Object.fromEntries(packingMaterials.map((p, i) => [`vorabName${i + 1}`, p.name]));
    const packmaterialBeginn = Object.fromEntries(packingMaterials.map((p, i) => [`beginnName${i + 1}`, p.name]));
    const effectivePackingMaterial = calculation.packingMaterial
        .slice()
        .sort((a, b) => packingMaterials.findIndex((p) => p.id === a.packingMaterial.id) -
        packingMaterials.findIndex((p) => p.id === b.packingMaterial.id));
    const mengeVorab = Object.fromEntries(packingMaterials
        .map((p) => effectivePackingMaterial.find((ep) => ep.packingMaterial.id === p.id))
        .map((p, i) => [
        `vorabMenge${i + 1}`,
        p != null && p.inAdvance > 0
            ? `${p.inAdvance} ${util_1.getUnit(p.packingMaterial.unit)}`
            : "",
    ]));
    const mengeBeginn = Object.fromEntries(packingMaterials
        .map((p) => effectivePackingMaterial.find((ep) => ep.packingMaterial.id === p.id))
        .map((p, i) => [
        `beginnMenge${i + 1}`,
        p != null && p.amount - p.inAdvance > 0
            ? `${p.amount - p.inAdvance} ${util_1.getUnit(p.packingMaterial.unit)}`
            : "",
    ]));
    const disassemblyItemsText = move.rooms
        .map((room) => {
        const disassemblyItems = room.items.filter((item) => item.disassembly);
        if (disassemblyItems.length > 0) {
            return `${room.name}: ${disassemblyItems
                .map((item) => item.name)
                .join(", ")}`;
        }
        return "";
    })
        .join(", ");
    const assemblyItemsText = move.rooms
        .map((room) => {
        const assemblyItems = room.items.filter((item) => item.assembly && !item.disposal);
        if (assemblyItems.length > 0) {
            return `${room.name}: ${assemblyItems
                .map((item) => item.name)
                .join(", ")}`;
        }
        return "";
    })
        .join(", ");
    return {
        kunde: util_1.getAddressVariables(move.customer),
        demontage: move.rooms.some((r) => r.items.some((i) => i.disassembly)),
        montage: move.rooms.some((r) => r.items.some((i) => i.assembly)),
        aussenaufzug: calculation.isLiftRequired,
        nurMoebelwagen: !((_d = (_b = (_a = move.recalculation) === null || _a === void 0 ? void 0 : _a.isTrailerRequired) !== null && _b !== void 0 ? _b : (_c = move.recalculation) === null || _c === void 0 ? void 0 : _c.isWithTruck) !== null && _d !== void 0 ? _d : calculation.isTrailerRequired),
        ...packmaterialVorab,
        ...mengeVorab,
        ...packmaterialBeginn,
        ...mengeBeginn,
        ablaufbeschreibungBeladestelle: (_g = (_f = (_e = move.documentData) === null || _e === void 0 ? void 0 : _e.workInstructions) === null || _f === void 0 ? void 0 : _f.processDescriptionLoading) !== null && _g !== void 0 ? _g : "",
        montagearbeitenBeladestelle: [
            (_k = (_j = (_h = move.documentData) === null || _h === void 0 ? void 0 : _h.workInstructions) === null || _j === void 0 ? void 0 : _j.assemblyWorkLoading) !== null && _k !== void 0 ? _k : "",
            disassemblyItemsText,
        ]
            .filter((item) => item.length > 0)
            .join(", "),
        halteverbotszoneBeladestelle: (_o = (_m = (_l = move.documentData) === null || _l === void 0 ? void 0 : _l.workInstructions) === null || _m === void 0 ? void 0 : _m.noParkingZoneLoading) !== null && _o !== void 0 ? _o : "",
        ablaufbeschreibungEntladestelle: (_r = (_q = (_p = move.documentData) === null || _p === void 0 ? void 0 : _p.workInstructions) === null || _q === void 0 ? void 0 : _q.processDescriptionUnloading) !== null && _r !== void 0 ? _r : "",
        montagearbeitenEntladestelle: [
            (_u = (_t = (_s = move.documentData) === null || _s === void 0 ? void 0 : _s.workInstructions) === null || _t === void 0 ? void 0 : _t.assemblyWorkUnloading) !== null && _u !== void 0 ? _u : "",
            assemblyItemsText,
        ]
            .filter((item) => item.length > 0)
            .join(", "),
        halteverbotszoneEntladestelle: (_x = (_w = (_v = move.documentData) === null || _v === void 0 ? void 0 : _v.workInstructions) === null || _w === void 0 ? void 0 : _w.noParkingZoneUnloading) !== null && _x !== void 0 ? _x : "",
    };
}
exports.default = getVariablesWorkInstructions;
//# sourceMappingURL=workInstructions.js.map